/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DataChartBoardBarsIcon16Light } from './DataChartBoardBarsIcon16Light';
import { DataChartBoardBarsIcon16Regular } from './DataChartBoardBarsIcon16Regular';
import { DataChartBoardBarsIcon16Solid } from './DataChartBoardBarsIcon16Solid';
import { DataChartBoardBarsIcon20Light } from './DataChartBoardBarsIcon20Light';
import { DataChartBoardBarsIcon20Regular } from './DataChartBoardBarsIcon20Regular';
import { DataChartBoardBarsIcon20Solid } from './DataChartBoardBarsIcon20Solid';
import { DataChartBoardBarsIcon24Regular } from './DataChartBoardBarsIcon24Regular';
import { DataChartBoardBarsIcon24Solid } from './DataChartBoardBarsIcon24Solid';
import { DataChartBoardBarsIcon32Regular } from './DataChartBoardBarsIcon32Regular';
import { DataChartBoardBarsIcon64Regular } from './DataChartBoardBarsIcon64Regular';
var sizes = {
    16: {
        light: DataChartBoardBarsIcon16Light,
        regular: DataChartBoardBarsIcon16Regular,
        solid: DataChartBoardBarsIcon16Solid,
    },
    20: {
        light: DataChartBoardBarsIcon20Light,
        regular: DataChartBoardBarsIcon20Regular,
        solid: DataChartBoardBarsIcon20Solid,
    },
    24: {
        regular: DataChartBoardBarsIcon24Regular,
        solid: DataChartBoardBarsIcon24Solid,
    },
    32: {
        regular: DataChartBoardBarsIcon32Regular,
    },
    64: {
        regular: DataChartBoardBarsIcon64Regular,
    },
};
export var DataChartBoardBarsIcon = forwardRef('DataChartBoardBarsIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
